import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Idempotent one-shot session exchange; useRef guard prevents StrictMode double-run.
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const intendedRole = localStorage.getItem("mm_google_role") || undefined;

    if (!sessionId) {
      setError("Missing session id");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-callback", {
          session_id: sessionId,
          intended_role: intendedRole,
        });
        localStorage.removeItem("mm_google_role");
        toast.success(`Welcome, ${data.user.name}`);
        // Full reload so AuthContext re-fetches /auth/me with the fresh cookie.
        window.location.replace(`/app/${data.user.role === "agency_admin" ? "agency" : data.user.role}`);
      } catch (e) {
        const msg = formatApiError(e.response?.data?.detail) || e.message;
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      }
    })();
    // Intentionally empty deps: this effect must run exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-black text-zinc-50 flex items-center justify-center p-6" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-4 rounded-full border-2 border-white/10 border-t-[#FFD700] animate-spin" />
        <p className="font-mono text-sm text-zinc-500">
          {error ? `Auth failed — ${error}` : "Completing sign-in…"}
        </p>
      </div>
    </div>
  );
}
